import { Box, Typography } from '@mui/material';

import { TeamHeader, TeamWrapper, UserLists } from '@styles/Admin-tools/TeamManagerStyle';

import { DealsButton } from '@styles/StyledButtons';
import { TEAM_MEMBER_TYPES } from '../../../Roles/RoleModal/models/RoleAssignmentModel';
import { AddTeamButton } from './components/AddTeamButton';
import { UsersList } from './components/UsersList';
import { NTeamManager } from './interfaces';

interface ITeam {
  index: number;
  team: NTeamManager.Team;
  displayAddButton: boolean;

  onAddTeam(): void;

  onEditTeam?(): void;
}

export const Team = ({ index, team, onAddTeam, onEditTeam, displayAddButton }: ITeam) => {
  return (
    <TeamWrapper>
      <TeamHeader>
        <Typography sx={{ pr: 1 }} fontSize="16px" variant="body1">
          {team.name}
        </Typography>

        <Box>
          <DealsButton color="primary" variant="contained" onClick={onEditTeam}>
            Edit
          </DealsButton>

          {displayAddButton && <AddTeamButton onAddTeam={onAddTeam} />}
        </Box>
      </TeamHeader>

      <UserLists>
        <UsersList
          showScroll
          height="12%"
          droppableId={index + '_' + TEAM_MEMBER_TYPES.Director}
          label={TEAM_MEMBER_TYPES.Director}
          data={team.roleUsers[TEAM_MEMBER_TYPES.Director]}
        />

        <UsersList
          showScroll
          height="12%"
          droppableId={index + '_' + TEAM_MEMBER_TYPES.Lieutenant}
          label={TEAM_MEMBER_TYPES.Lieutenant}
          data={team.roleUsers[TEAM_MEMBER_TYPES.Lieutenant]}
        />

        <UsersList
          showScroll
          height="70%"
          droppableId={index + '_' + TEAM_MEMBER_TYPES.Member}
          label={TEAM_MEMBER_TYPES.Member}
          data={team.roleUsers[TEAM_MEMBER_TYPES.Member]}
        />
      </UserLists>
    </TeamWrapper>
  );
};
